import { Tooltip as MuiTooltip, TooltipProps } from "@mui/material";
import { forwardRef } from "react";

export const Tooltip = forwardRef<HTMLElement, TooltipProps>(
  ({ title, children, placement = "top", ...otherProps }, ref) => {
    return (
      <MuiTooltip
        ref={ref}
        title={title}
        placement={placement}
        arrow
        enterTouchDelay={0}
        leaveTouchDelay={10000}
        {...otherProps}
      >
        {children}
      </MuiTooltip>
    );
  },
);

export default Tooltip;
